<template>
  <!-- 2026-07-23 15:30：菜单翻译键缺失时使用功能名称，兼容已有本地缓存。 -->
  <div class="siderbar-menu">
    <a-menu
      mode="inline"
      theme="dark"
      :inline-collapsed="!store.getters.sideBarOpened"
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
    >
    <template  v-for="(menu,index) in menus" >
      <a-sub-menu v-if="menu.children && menu.children.length>0"  :key="menu.path">
        <template #icon>
          <svg-icon  :class="[store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']" :icon="menu.icon"></svg-icon> 
        </template>
        <template #title>{{generateTitle(menu.key || menu.title)}}</template>
        <a-menu-item v-for="(submenu,sindex) in menu.children"  @click="menuClick(submenu,'ss'+sindex)" :key="submenu.path">{{generateTitle(submenu.key || submenu.title)}}</a-menu-item>
        
      </a-sub-menu>
      <a-menu-item v-else :key="'ss'+menu.path" @click="menuClick(menu,'k'+index)">
        <template #icon>          
              <svg-icon  :class="[store.getters.sideBarOpened?'menu-icon':'plus-menu-icon']" :icon="menu.icon"></svg-icon>          
        </template>
        <span>{{generateTitle(menu.key || menu.title)}}</span>
      </a-menu-item>      
    </template>  
    </a-menu>
    <div class="org-info"><div>{{userInfo.orgName}}</div><div>({{ userInfo.roleName }})</div></div>
  </div>
</template>
<script lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { defineComponent, ref,reactive,toRefs,watch, computed, onMounted } from 'vue'
import { getMenus } from '@/utils/route'
import { generateTitle } from '@/utils/lang'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  MailOutlined,
  DesktopOutlined,
  InboxOutlined,
  AppstoreOutlined,
} from '@ant-design/icons-vue';
import store from '@/store'
import sysRequest from '@/api/sys'
import components from '@/components/index';
type MenuItem = {
  title:string,
  path:string,
  key:string,
  icon:string,
  expaned?:boolean,
  children?:Array<MenuItem>
}
export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()
    const routes = getMenus(router.getRoutes())
    const openKeys = ref<string[]>([])
      const state = reactive({
      collapsed: false,
      selectedKeys: ['/platform/platforminfo'],
      openKeys: ['/platform/platforminfo'],
      preOpenKeys: ['sub1'],
    });
    const menuClick = (menu:MenuItem,key:string) => {
      if (!menu.children) {
        if(menu.path==='/products/bokes'){
          router.push({  
            path: menu.path,  
            query: {productType:0}
          });
        }else{
          router.push(menu.path)
        }
        
      }
    }
    const userInfo=computed(()=>{
      return store.getters.userInfo
    })
      
    watch(
      () => state.openKeys,
      (val, oldVal) => {
        state.preOpenKeys = oldVal;
      },
    );
    const menus = ref<MenuItem[]>([])    
    const openMenu = (menu) => {
      let index = openKeys.value.indexOf(menu.path)
      if (index != -1) {
        openKeys.value.splice(index, 1)
      } else {
        openKeys.value = [menu.path]
      }
    }
    const expaned = (menu) => {
      menu.expaned=!menu.expaned;
    }
    const getAllFunctions =async () =>{
        const funcs=[...store.getters.functions.parentFunc]
        store.getters.functions.allFunc.forEach(itm=>{
          if(itm.functionType=='MENU'){
            funcs.push(itm)
          }         
        })
        menus.value=funcs.reduce((acc,item)=>{          
          if(item.parentId==0){
            acc.push({title:item.functionName,key:item.functionKey, path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
          }else{
            const itm=acc.find(itm=>itm.id==item.parentId)
            if(itm){
              if(!itm.children)
                itm.children=[]
              itm.children.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
            }
          }
          return acc
        },[])  
        for(let i=0;i<menus.value.length;i++){
          if(!menus.value[i].children || menus.value[i].children?.length==0){
            menus.value.splice(i,1)
            i--;
          }
        } 
        console.log(menus.value)
    }
    const getRoleFunctions = async (roleId) => {      
      const fs=store.getters.functions.allFunc?.sort((b,a)=>{
          return b.sortIndex-a.sortIndex
        })
        const funcs=[...store.getters.functions.parentFunc]
        fs.forEach(itm=>{
          if(itm.functionType=='MENU'){
            funcs.push(itm)
          }        
        })
        menus.value=funcs.reduce((acc,item)=>{          
          if(item.parentId==0){
            acc.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
          }else{
            const itm=acc.find(itm=>itm.id==item.parentId)
            if(itm){
              if(!itm.children)
                itm.children=[]
              itm.children.push({title:item.functionName,key:item.functionKey,path:item.functionUrl,icon:item.icon,parentId:item.parentId,id:item.id})
            }
          }
          return acc
        },[])    
        for(let i=0;i<menus.value.length;i++){
          if(!menus.value[i].children || menus.value[i].children?.length==0){
            menus.value.splice(i,1)
            i--;
          }
        }  
    }
    onMounted(() => {
      if(store.getters.userInfo.roleId==1){  //如果是管理员，直接取所有菜单
        getAllFunctions()
      }else{
        getRoleFunctions(store.getters.userInfo.roleId)
      }
    })
    return {
      menuClick, ...toRefs(state),openMenu, store, generateTitle, openKeys, routes, route,menus,expaned,userInfo
    }
  },
  components:{
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PieChartOutlined,
    MailOutlined,
    DesktopOutlined,
    InboxOutlined,
    AppstoreOutlined,
  }
})

</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.module.scss';
.siderbar-menu {
  cursor: pointer;
  height:calc(100vh - 100px);
  overflow-y:auto;
  .org-info{
    color:lightgray;
    position: fixed;
    bottom:5px;
    display:flex;
    flex-wrap: wrap;
    width:var(--sideBarWidth);
    left:5px;
  }
  .siderbar-submenu {
    position: relative;
    padding: 8px 0;
  }

  .siderbar-menu-item {
    position: relative;
    box-sizing: border-box;
    background-color: $menuBg;
    color: #fff;
    &:first-child {
      margin-top: 0;
    }
  }

  .siderbar-menu-item-title {
    box-sizing: border-box;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    white-space: nowrap;
  }
  .siderbar-submenu-item-title{
    box-sizing: border-box;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    white-space: nowrap;
    margin-left:20px;
  }
  .siderbar-menu-title-content {
    margin-left: 10px;
  }

  .siderbar-child-menu-title-content {
    margin-left: 48px;
  }

  .active-menu-item {   
    color: white;
    .siderbar-menu-item-title {
      
      background: #1890ff;
    }
  }

  .menu-icon {
    font-size: 18px !important;
  }

  .plus-menu-icon {
    font-size: 24px !important;
    
  }
  
  .right-arrow-icon {
    position: absolute;
    right: 12px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
